import { render, staticRenderFns } from "./SetAssignUserToDomain.vue?vue&type=template&id=903a315a"
import script from "./SetAssignUserToDomain.vue?vue&type=script&lang=js"
export * from "./SetAssignUserToDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports